<template>
  <div class="mb-6">
    <v-row no-gutters>
      <span class="checkout-h6 accent--text" style="font-weight: 700">
        {{ $t("payment.purchasePolicy") }}
      </span>
    </v-row>
    <v-row class="py-4" no-gutters>
      <v-card
        outlined
        class="rounded-lg pa-3"
        width="100%"
        height="200"
        max-height="200"
        style="overflow: auto"
      >
        <span v-html="eventDetails?.politica_compra"></span>
      </v-card>
    </v-row>
    <v-row no-gutters>
      <v-checkbox
        class="ma-0 pa-0"
        hide-details
        label="Aceito os termos"
        required
        :rules="[rulesValidation.required]"
      ></v-checkbox>
    </v-row>
  </div>
</template>

<script>
import validationMixin from "../../mixins/validationMixin.vue";
export default {
  props: ["eventDetails"],
  mixins: [validationMixin],
};
</script>
